import { Pipe, PipeTransform } from '@angular/core';
import { PaymentStatus, paymentStatusLabelMappings } from '@/common/enums/paymentStatus';

@Pipe({
	name: 'paymentStatusLabel',
	standalone: true,
})
export class PaymentStatusLabelPipe implements PipeTransform {
	transform(status: PaymentStatus | string | null | undefined): string {
		if (!status) {
			return '';
		}

		return paymentStatusLabelMappings[status as PaymentStatus] ?? '';
	}
}
